import React, { useState, useEffect } from "react";

function FormContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    updates_through_email_or_text: "No",
    _id: "",
    subject: "Contact-Us Form: ",
  });

  const [isLoading, setIsLoading] = useState(false);

  function generateId() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const date = String(now.getDate()).padStart(2, "0");
    const day = now.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${year}${month}${date}${day}${hours}${minutes}${seconds}`;
  }

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      _id: generateId(),
    }));
  }, []);

  // function handleChange(e) {
  //   const { name, value, type, checked } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value,
  //   }));
  // }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      // Remove all non-digits
      let digits = value.replace(/\D/g, "");

      // Limit to 10 digits
      digits = digits.substring(0, 10);

      // Format as XXX-XXX-XXXX
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if (digits.length > 3) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }

      setFormData((prev) => ({
        ...prev,
        phone: formatted,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value,
      }));
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const data = new FormData();

    // Build subject dynamically
    const subject =
      formData.subject + formData.firstName + " " + formData.lastName;

    const payload = {
      ...formData,
      subject,
    };

    Object.entries(payload).forEach(([key, value]) => {
      data.append(key, value);
    });

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbzYjASnEysk5jQdsYeDXVRD7vXc9T2RicoH8_P5a3UQyVIS6o9PIYUTDoDG77P5vyZLuQ/exec";

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        body: data,
      });

      if (response.ok) {
        alert("Form submitted successfully!");
        window.location.reload();
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error!", error.message);
      alert("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="purchaseBottomRightBox FreeQuoteBox">
      <form
        className={`purchaseBottomRightform ${isLoading ? "loading" : ""}`}
        onSubmit={handleSubmit}
      >
        <div>GET IN TOUCH</div>
        <input
          type="text"
          placeholder="FIRST NAME:"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          placeholder="LAST NAME:"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          placeholder="EMAIL:"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          placeholder="PHONE:"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          maxLength="12"
          // pattern="[0-9]*"
          inputMode="numeric"
          required
        />

        <textarea
          rows="5"
          placeholder="MESSAGE:"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        />

        <div className="contactUsFormUpdatesEmailandText">
          <label>
            <span>Would you like to receive updates by email or text?</span>
            <br />
            <span className="contactUsFormUpdatesEmailandTextLabelSpan2">
              <input
                type="checkbox"
                name="updates_through_email_or_text"
                checked={formData.updates_through_email_or_text === "Yes"}
                onChange={handleChange}
              />{" "}
              {formData.updates_through_email_or_text}
            </span>
          </label>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default FormContactUs;
